import useFormatter from "@/hooks/use-formatter.hook.ts";
import { PreboardingTaskRow } from "@/pages/preboarding/components/PreboardingTaskRow.tsx";
import { PreboardingTaskModal } from "@/pages/preboarding/widgets/PreboardingTaskModal.tsx";
import { ApiPreboardingTask } from "@/types/preboarding.types.ts";
import { ApiTaskStatus } from "@/types/task.types.ts";
import {
  Button,
  DotSeparator,
  FontAwesomeIcon,
  Stack,
  Tag,
  Text,
  useModals,
} from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

interface PreboardingTodoRowProps {
  task: ApiPreboardingTask;
}

export function PreboardingTodoRow({ task }: PreboardingTodoRowProps) {
  const { t } = useTranslation();
  const { renderDate } = useFormatter();
  const { openModal } = useModals();

  const hasDate = task.date_due !== null;
  const hasFiles = task.files.length > 0;

  return (
    <PreboardingTaskRow
      icon={<FontAwesomeIcon icon="fa-light fa-check" className={"text-[22px]"} />}
      title={task.title}
      action={
        <Stack direction={"horizontal"} gap={"sm"} items={"center"}>
          {task.status === ApiTaskStatus.in_progress && (
            <Tag variant={"new"}>{t("tasks:task_status_in_progress")}</Tag>
          )}
          <Button
            variant={"plain"}
            rightIcon={<FontAwesomeIcon icon="fa-light fa-chevron-right" />}
            onClick={() => openModal(PreboardingTaskModal, { task })}
          >
            {t("common:open")}
          </Button>
        </Stack>
      }
      caption={
        hasDate || hasFiles ? (
          <DotSeparator>
            {task.date_due && <Text className={"text-secondary"}>{renderDate(task.date_due)}</Text>}
            {hasFiles && (
              <Text className={"text-secondary inline-flex items-center gap-1"}>
                <FontAwesomeIcon icon="fa-light fa-paperclip" />
                {task.files.length}
              </Text>
            )}
          </DotSeparator>
        ) : undefined
      }
    />
  );
}
